import { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import type { CoverageValues } from '../types'
import { CoverageForm } from './CoverageForm'

interface Props {
  open: boolean
  initial: CoverageValues
  onClose: () => void
  onSave: (next: CoverageValues) => void
  onReset?: () => void
}

export function CoverageModal({ open, initial, onClose, onSave, onReset }: Props) {
  const [draft, setDraft] = useState<CoverageValues>(initial)

  useEffect(() => {
    if (open) setDraft(initial)
  }, [open, initial])

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-5xl">
        <DialogHeader>
          <DialogTitle>Individuální pojistné krytí</DialogTitle>
        </DialogHeader>
        <CoverageForm value={draft} onChange={setDraft} />
        <DialogFooter className="justify-between">
          <div>
            {onReset && (
              <Button variant="ghost" onClick={onReset}>
                Použít globální nastavení
              </Button>
            )}
          </div>
          <div className="flex gap-2">
            <Button variant="outline" onClick={onClose}>
              Zrušit
            </Button>
            <Button onClick={() => onSave(draft)}>Uložit změny</Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
